const building: any[] = [
    {
        label: 'Lt 21',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'SLK & KCK - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt21/slk&kck/1' },
            { label: 'SLK & KCK - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt21/slk&kck/2' },
        ]
    },
    {
        label: 'Lt 20',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'SLK - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt20/slk/2' },
            { label: 'SLK - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt20/slk/1' },
        ]
    },
    {
        label: 'Lt 19',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'SLK - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt19/slk/1' },
        ]
    },
    {
        label: 'Lt 18',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'DPOL - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt18/dpol/1' },
            { label: 'DPOL - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt18/dpol/2' },
        ]
    },
    {
        label: 'Lt 17',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'LOGISTIK KP - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt17/logistikkp/1' },
            { label: 'LOGISTIK KP - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt17/logistikkp/2' },
        ]
    },
    {
        label: 'Lt 16',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'LOGISTIK KP - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt16/logistikkp/1' },
            { label: 'LOGISTIK KP - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt16/logistikkp/2' },
        ]
    },
    {
        label: 'Lt 15',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT ACA - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt15/ptaca/1' },
            { label: 'PT ACA - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt15/ptaca/2' },
        ]
    },
    {
        label: 'Lt 14',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT ACA - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt14/ptaca/1' },
            { label: 'PT ACA - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt14/ptaca/2' },
        ]
    },
    {
        label: 'Lt 12 A',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT ACA - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt12a/ptaca/1' },
            { label: 'PT ACA - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt12a/ptaca/2' },
        ]
    },
    {
        label: 'Lt 12',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT ACA - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt12/ptaca/1' },
            { label: 'PT ACA - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt12/ptaca/2' },
        ]
    },
    {
        label: 'Lt 11',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT CAR - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt11/ptcar/1' },
            { label: 'PT CAR - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt11/ptcar/2' },
            { label: 'PT CAR - Tambahan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt11/ptcar/3' },
        ]
    },
    {
        label: 'Lt 10',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT ACA 1 - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt10/ptaca1/1' },
            { label: 'PT ACA 1 - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt10/ptaca1/2' },
            { label: 'PT ACA 1 - Tambahan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt10/ptaca1/3' },
        ]
    },
    {
        label: 'Lt 9',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'BCA-MDP - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt9/bca-mdp/1' },
            { label: 'BCA-MDP - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt9/bca-mdp/2' },
            { label: 'SK - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt9/sk/1' },
        ]
    },
    {
        label: 'Lt 8',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'BCA KANWIL XII - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt8/bcakanwilxii/1' },
        ]
    },
    {
        label: 'Lt 7',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'KANTIN - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt7/kantin/1' },
            { label: 'KANTIN - Tambahan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt7/kantin/3' },
        ]
    },
    {
        label: 'Lt 6',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PARKIR - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt6/parkir/1' },
        ]
    },
    {
        label: 'Lt 5',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'DOSIR - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt5/dosir/1' },
            { label: 'PARKIR - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt5/parkir/1' },
            { label: 'PARKIR - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt5/parkir/2' },
        ]
    },
    {
        label: 'Lt 4',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT BCA-KCU WAS - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt4/ptbca-kcuwas/1' },
        ]
    },
    {
        label: 'Lt 3',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT BCA-KCU WAS - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lt3/ptbca-kcuwas/1' },
        ]
    },
    {
        label: 'Lobby',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'PT BCA-KCU WAS - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lobby/ptbca-kcuwas/1' },
            { label: 'PT BCA-KCU WAS - Tambahan', icon: 'pi pi-fw pi-bookmark', to: '/detail/lobby/ptbca-kcuwas/3' },
        ]
    },
    {
        label: 'GF',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'BCA KANWIL XII - Penerangan', icon: 'pi pi-fw pi-bookmark', to: '/detail/gf/bcakanwilxii/1' },
            { label: 'BCA KANWIL XII - AC', icon: 'pi pi-fw pi-bookmark', to: '/detail/gf/bcakanwilxii/2' },
        ]
    },
    {
        label: 'Incoming',
        icon: 'pi pi-fw pi-building',
        items: [
            { label: 'Incoming PLN', icon: 'pi pi-fw pi-bookmark', to: '/detail/incoming/incomingpln/3' },
        ]
    },
]

export default building

export const titleMap = {
    'lt21/slk&kck/1': 'PANEL PENERANGAN LT 21',
    'lt21/slk&kck/2': 'PANEL AC LT 21',
    'lt20/slk/2': 'PANEL PENERANGAN LT 20',
    'lt20/slk/1': 'PANEL AC LT 20',
    'lt19/slk/1': 'PANEL PENERANGAN LT 19',
    'lt18/dpol/1': 'PANEL PENERANGAN LT 18',
    'lt18/dpol/2': 'PANEL AC LT 18',
    'lt17/logistikkp/1': 'PANEL PENERANGAN LT 17',
    'lt17/logistikkp/2': 'PANEL AC LT 17',
    'lt16/logistikkp/1': 'PANEL PENERANGAN LT 16',
    'lt16/logistikkp/2': 'PANEL AC LT 16',
    'lt15/ptaca/1': 'PANEL PENERANGAN LT 15',
    'lt15/ptaca/2': 'PANEL AC LT 15',
    'lt14/ptaca/1': 'PANEL PENERANGAN LT 14',
    'lt14/ptaca/2': 'PANEL AC LT 14',
    'lt12a/ptaca/1': 'PANEL PENERANGAN LT 12.A',
    'lt12a/ptaca/2': 'PANEL AC LT 12.A',
    'lt12/ptaca/1': 'PANEL PENERANGAN LT 12',
    'lt12/ptaca/2': 'PANEL AC LT 12',
    'lt11/ptcar/1': 'PANEL PENERANGAN LT 11',
    'lt11/ptcar/2': 'PANEL AC LT 11',
    'lt11/ptcar/3': 'PANEL KOMPUTER LT 11',
    'lt10/ptaca1/1': 'PANEL PENERANGAN LT 10',
    'lt10/ptaca1/2': 'PANEL AC LT 9',
    'lt10/ptaca1/3': 'PANEL KOMPUTER LT 10',
    'lt9/bca-mdp/1': 'PANEL PENERANGAN LT 9	wismabca1/',
    'lt9/bca-mdp/2': 'PANEL AC LT 9	wismabca1/',
    'lt9/sk/1': 'PANEL SK 1 LT 9',
    'lt8/bcakanwilxii/1': 'PANEL PENERANGAN LT 8',
    'lt7/kantin/1': 'PANEL PENERANGAN LT 6',
    'lt7/kantin/3': 'PANEL KANTIN LT 7',
    'lt6/parkir/1': 'PANEL PENERANGAN LT 6',
    'lt5/dosir/1': 'DOSIR LT 5',
    'lt5/parkir/1': 'PANEL PENERANGAN LT 5',
    'lt5/parkir/2': 'PANEL AC LT 5',
    'lt4/ptbca-kcuwas/1': 'PANEL PENERANGAN LT 4',
    'lt3/ptbca-kcuwas/1': 'PANEL PENERANGAN LT 3',
    'lobby/ptbca-kcuwas/1': 'PANEL PENERANGAN LOBBY',
    'lobby/ptbca-kcuwas/3': 'PANEL LOBBY',
    'gf/bcakanwilxii/1': 'PANEL PENERANGAN LT GF',
    'gf/bcakanwilxii/2': 'PANEL AC LT GF',
    'incoming/incomingpln/3': 'INCOMING PLN PM5330',
}